<template>
  <div class="listing-select">
    <select
      :id="'listing-select-' + name"
      :name="name"
      class="listing-select__select"
      @change="onSelectItem()"
    >
      <option v-if="placeholderText" value="">
        {{ placeholderText }}
      </option>
      <option
        v-for="item in items"
        :key="item.key"
        :value="item.key"
        :selected="item.active"
      >
        {{ item.value }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'ListingSelect',
  props: {
    name: {
      type: String,
      default: '',
    },
    group: {
      type: String,
      default: '1',
    },
    placeholderText: {
      type: String,
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onSelectItem() {
      this.$emit('change');
    },
  },
};
</script>

<style scoped lang="scss">
.listing-select {
  $block-selector: &;
  $padding: 0.62em;

  position: relative;
  font-family: $font-default;
  font-size: 1em;
  font-weight: 500;

  &::after {
    @extend %icon;
    @extend %icon--arrow-fill-bottom;
    font-size: 0.5em;
    position: absolute;
    top: 50%;
    right: $padding + 1em;
    transform: translate3d(0, -50%, 0);
  }

  &__select {
    display: flex;
    line-height: 1.5rem;
    align-items: center;
    background-color: $color-grey-wild-sand;
    border: solid $color-gray-mercury 1px;
    border-radius: 0.625rem;
    padding: $padding 2em $padding $padding;
    cursor: pointer;
    appearance: none;
    color: $color-grey-boulder;
  }
}
</style>
